module.exports = __webpack_public_path__ + "static/media/Tuzo-Preloader-Transparent.480bcad5.gif";